<template>
  <div class="nuttrema-loader" :class="[`theme-${theme}`]">
    <div class="nuttrema-loader__loading">
      <div v-if="showImage" class="nuttrema-loader__image">
        <img class="nuttrema-loader__image--turquoise" src="~assets/images/diet-creator-loader.svg" alt="Loading...">
        <img class="nuttrema-loader__image--white" src="~assets/images/diet-creator-loader--white.svg" alt="Loading...">
      </div>
      <h4
        v-if="showText"
        class="loading-dot-blink">
        {{ $t(loadingText) }} <span>.</span><span>.</span><span>.</span>
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-loader',
  props: {
    showImage: {
      type: Boolean,
      required: false,
      default: true,
    },
    showText: {
      type: Boolean,
      required: false,
      default: true,
    },
    loadingText: {
      type: String,
      required: false,
      default: 'label.loading',
    },
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
  },
};
</script>

<style lang="scss" scoped>

.nuttrema-loader {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  flex-grow: 1;
  height: 100%;
  display: flex;
  position: absolute;
  align-self: stretch;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: rgba(255,255,255,0.75);

  .nuttrema-loader__loading{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .nuttrema-loader__image {
      width: 100px; height: 100px;
      img {
        width: 100px; height: 100px;
      }
    }

    .nuttrema-loader__image--turquoise { display: block; }
    .nuttrema-loader__image--white { display: none; }
  }

  &.theme-relative {
    position: relative;
  }

  &.theme-transparent {
    background-color: transparent;
  }

  &.theme-white {
    background-color: transparent;

    .nuttrema-loader__loading {
      .loading-dot-blink {
        color: #fff;
      }
    }

    .nuttrema-loader__image--turquoise { display: none; }
    .nuttrema-loader__image--white { display: block; }
  }

  &.theme-grey-logo {
    &:after {
      z-index: 0;
      width: 100%;
      content: '';
      height: 100%;
      opacity: 0.05;
      position: absolute;
      background-size: 60%;
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: 125% 125%;
      background-image: url('~assets/images/dc-logo-small-gray.svg');
    }
  }

  &.theme-full-overlay {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    position: absolute;
    background-color: rgba(255, 255, 255, 0.90);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/panels/nuttrema-loader.vue